
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/notifications",
      function () {
        return require("private-next-pages/dashboard/notifications/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/notifications"])
      });
    }
  